import { Component } from '@angular/core';

@Component({
  selector: 'simulator-page',
  templateUrl: './simulator.page.html',
})

export class SimulatorPageComponent {}
